module.exports = __webpack_public_path__ + "assets/img/title-20c9bd92.png";